const routes = [
  {
    path: 'card3D',
    name: 'card3D',
    component: () => import(/* webpackChunkName: "card3D" */ '@/modules/card3D/index.vue')
  },
];

export default routes;